import { Injectable } from '@angular/core';
import { CiselnikItemXmlDto } from '../dto/CiselnikItemXmlDto';
import { SelectItem } from '../interfaces/select-item';


/**
 * Pomocný nástroj k číselníkům.
**/
@Injectable({
	providedIn: 'root'
})
export class CiselnikyUtils {


	/**
	* Prevede SelectItem na CiselnikItemXmlDto
	* @param value
	*/
	public SelectItemToCiselik(value: SelectItem): CiselnikItemXmlDto {
		return { popis: value.label, kod: value.value }
	}
}
